// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', {setPrototypeOf: require('./_set-proto').set});


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/es6.object.set-prototype-of.js
// module id = 421
// module chunks = 0